import { render } from "./LoginSolidary.view.vue?vue&type=template&id=3838d49a"
import script from "./LoginSolidary.view.vue?vue&type=script&lang=js"
export * from "./LoginSolidary.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__